<script>
import CandelaComponent from '@/components/CandelaComponent'

import {grouped_bars} from '@/components/plots/atoms'
import {AxisNames, Orientations, DomainTypes, ScaleTypes} from '@/components/plots/enums'

export default {
  computed: {
    band_scale() {
      if(this.axis_y && this.axis_x) {
        return this.is_horizontal ? this.axis_y.scale : this.axis_x.scale
      }
      return null
    },
    bars() {
      return grouped_bars(
        this.x, this.y, this.band_scale, this.cont_scale, this.orientation)
    },
    cont_scale() {
      if(this.axis_x && this.axis_y) {
        return this.is_horizontal ? this.axis_x.scale : this.axis_y.scale
      }
      return null
    },
    colors() {
      return this.y.data[0].map((d, i, v) => {
        return this.settings.colors.value(i/v.length)
      })
    },
    is_horizontal() { return this.orientation === Orientations.Horizontal },
    domain_type() { return DomainTypes.MinMax }
  },
  data() {
    return {
      AxisNames,
      Orientations,
      ScaleTypes,
      axis_x: null,
      axis_y: null,
      plot_key: 0
    }
  },
  extends: CandelaComponent,
  methods: {
    update(axes) {
      this.axis_x = this.is_horizontal ? axes.x2 : axes.x
      this.axis_y = axes.y
    }
  },
  name: 'candela-grouped-bar-chart',
  props: {
    orientation: {type: String, default: () => Orientations.Vertical},
    x: {type: Object, default: () => null},
    y: {type: Object, default: () => null}
  },
  watch: {
    orientation() {
      // When the orientation changes,
      // we need to completely re-build the plot.
      // This key is used the "key" param of the plot element below
      // When it changes, the element is refreshed
      this.plot_key++
    }
  }
}
</script>

<template>
<div class='candela-component'>
  <candela-plot ref='plot' :id='id' :frame='frame' @update='update'
    :key='`plot-key-${plot_key}`'>
    <candela-axis v-if='is_horizontal' :slot='AxisNames.Y' v-bind='x'
      :scale_type='ScaleTypes.Band' :padding='0.15'
      :domain_type='domain_type'/>
    <candela-axis v-else-if='y' :slot='AxisNames.Y' v-bind='y'
      :domain_type='domain_type'/>

    <candela-axis v-if='is_horizontal' :slot='AxisNames.X2' v-bind='y'
      :domain_type='domain_type'/>
    <candela-axis v-else-if='x' :slot='AxisNames.X' v-bind='x'
      :scale_type='ScaleTypes.Band' :padding='0.15'/>

    <g slot='content'>
      <candela-grid-lines v-if='settings.show_grid.value'
        :axis_x='axis_x' :axis_y='axis_y'/>
      <rect v-for='(bar, i) in bars' :key='i'
        :fill='colors[bar.i]'
        :x='bar.x' :y='bar.y' :width='bar.width' :height='bar.height'/>
    </g>

    <div slot='bottom-content'>
      <candela-legend v-if='settings.show_legend.value'
        :index='y.index' :title='y.variable' :colors='colors'/>
    </div>
  </candela-plot>
</div>
</template>
